import { render, staticRenderFns } from "./BuroDetayView.vue?vue&type=template&id=3ec64382&scoped=true"
import script from "./BuroDetayView.vue?vue&type=script&lang=ts"
export * from "./BuroDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec64382",
  null
  
)

export default component.exports